var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasRoot",staticClass:"silo-profile-canvas-root",attrs:{"id":_vm.profileContainerId}},[_c('canvas',{attrs:{"id":_vm.profileCanvasId}})])}
var staticRenderFns = []

export { render, staticRenderFns }